import React from 'react';
import ReactDOM from 'react-dom';
import '../../sass/components/early_bird_info.scss';
import EarlyBirdModal from './earlyBird_modal/index';

// import get from '../helpers/data_layer/get';

const modalMount = document.getElementById('EarlyBirdModal');
if (modalMount) {
  ReactDOM.render(<EarlyBirdModal />, modalMount);
}
